


















import { Component, Vue } from "vue-property-decorator";
import "@/rem";
import Cookie from "js-cookie";
@Component({
  components: {
    InsHeader: () => import("@/components/business/header/InsHeader.vue"),
    InsFooter: () => import("@/components/business/footer/InsFooter.vue"),
    // InsSlideMenu: () => import("@/components/business/header/InsSlideMenu.vue"),
    'InsSlideMenu': () => import('@/components/business/header/InsSlideMenu.vue'),
    'InsSlideMenuP': () => import('@/components/business/header/InsSlideMenuP.vue'),
    NewMeun: () => import("@/components/business/header/NewMeun.vue"),
    InsMenuLayout: () =>
      import("@/components/siteBusiness/header/InsMenuLayout.vue"),
    InsSidebar: () => import("@/components/business/header/InsSidebar.vue"),
  },
})
export default class mobileIndex extends Vue {
  created() {
    Vue.prototype.vw = window.innerWidth;
    this.changLange(this.$Storage.get("locale") || "E");
  }
  get isHideHeaderRoute() {
    const currentPath = this.$route.path;
    const routeName = this.$route.name;

    // 路径匹配条件
    const pathMatch = [
      "/building",
      "/Tony",
      "/Elsa",
      "/Karen",
      "/Kay",
      "/Tachy",
      "/Vince",
      "/Winson",
      "/Ryan",
      "/Owen",
      "/Shirley",
    ].includes(currentPath);

    // 名称匹配条件
    const nameMatch =
      routeName && ["Tony", "Elsa", "Karen", "Kay", "Tachy", "Vince", "Winson", "Ryan", "Owen", "Shirley"].some((name) => routeName.includes(name));

    return pathMatch || nameMatch;
  }
  get routerPath() {
    return this.$route.path;
  }

  get SlideMenuType () {
    if (this.isMobile) {
      return 'InsSlideMenu';
    } else {
      return 'InsSlideMenuP';
    }
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  private changLange (lang) {
    this.$Api.member.setUILanguage(lang).then((result) => {
      this.$i18n.locale = lang;
      this.$Storage.set('locale', lang);
    }).catch((error) => {
      console.log(error);
    });
  }
}
